import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { CashoutStatusComponent } from "src/app/components/cashout/cashout-status/cashout-status.component";
import { CashoutSuccessComponent } from "src/app/components/cashout/cashout-success/cashout-success.component";
import { CashoutTooltipComponent } from "src/app/components/cashout/cashout-tooltip/cashout-tooltip.component";
import { ComponentModule } from "src/app/components/component.module";
import { CashoutComponent } from "./cashout/cashout.component";


import { HttpClient } from "@angular/common/http";
import { AuthService } from "@core/auth.service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { FirestoreTransLoader } from "src/app/services/firestore.service";

// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
// }
export function FirestoreTranslationsLoaderFactory(http: HttpClient, authService: AuthService) {
  return new FirestoreTransLoader(http);
}

const routes: Routes = [
  {
    path: "",
    component: CashoutComponent,
  },
  {
    path: "cashoutStatus",
    component: CashoutStatusComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    ComponentModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: FirestoreTranslationsLoaderFactory,
        deps: [HttpClient, AuthService],
      },
      defaultLanguage: "en",
    }),
    CashoutComponent, CashoutStatusComponent, CashoutSuccessComponent, CashoutTooltipComponent,
  ],
})
export class CashoutModule { }
